module.exports = __webpack_public_path__ + "static/portfolio-6-09c4e0c1d651bf890cde5af21f770326.jpg";